import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppLoginRoutingModule } from './app-login-routing.module';
import { LoginSectionComponent } from './login-section/login-section.component';
import { PrimengModule } from '../shared/modules/primeng.module';
import { EmailOtpVerificationComponent } from './email-otp-verification/email-otp-verification.component';
import { FindYourAccountComponent } from './find-your-account/find-your-account.component';
import { ForgotEmailComponent } from './forgot-email/forgot-email.component';
import { OtpConfirmationScreenComponent } from './otp-confirmation-screen/otp-confirmation-screen.component';
import { PasswordVerificationSuccessPopupComponent } from './password-verification-success-popup/password-verification-success-popup.component';
import { PhOtpVerificationComponent } from './ph-otp-verification/ph-otp-verification.component';
import { SetNewPasswordComponent } from './set-new-password/set-new-password.component';
import { ForgotPasswordEmailComponent } from './forgot-password-email/forgot-password-email.component';
import { ForgotPasswordPhoneComponent } from './forgot-password-phone/forgot-password-phone.component';
import { VerifyForgotPasswordComponent } from './verify-forgot-password/verify-forgot-password.component';
import { SharedPipesModule } from '@app/@core/pipes/shared-pipes.module';


@NgModule({
  declarations: [
    LoginSectionComponent,
    EmailOtpVerificationComponent,
    FindYourAccountComponent,
    ForgotEmailComponent,
    OtpConfirmationScreenComponent,
    PasswordVerificationSuccessPopupComponent,
    PhOtpVerificationComponent,
    SetNewPasswordComponent,
    ForgotPasswordEmailComponent,
    ForgotPasswordPhoneComponent,
    VerifyForgotPasswordComponent,
    // RaiseAComplaintComponent,
    // UpdateEmailComponent
     
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AppLoginRoutingModule,
    FormsModule,
    PrimengModule,
    SharedPipesModule
  ]
})
export class AppLoginModule { }
